// extracted by mini-css-extract-plugin
export default {"cls1":"VeloFileUpload-Divider_cls1__4r+uQ","cls2":"VeloFileUpload-Divider_cls2__zgWA0 VeloFileUpload-Divider_cls1__4r+uQ"};